import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useOutletContext } from "react-router-dom";
import { BadgeusesTab } from "./Badgeuse/BadgeusesTab";
import { ProjectsTab } from "./Project/ProjectsTab";
import { TeamsTab } from "./Team/TeamsTab";
import { HolidaysTab } from "./OpenHolidays/HolidaysTab";
import { getEstablishment } from "../../../../_api/Establishment";
import { Loader } from "../../../../_helpers/components/Forms/Loader";

const Establishment = () => {
    const navigate = useNavigate();
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();

    const [establishment, setEstablishment] = useState(null);

    const { establishment_id } = useParams();

    const loadEstablishment = () => {
        getEstablishment(establishment_id).then((resp) => {
            setEstablishment(resp.data);
        });
    };

    useEffect(() => {
        loadEstablishment();
    }, []);

    return (
        <div className="max-w-7xl mx-auto p-4 space-y-6">
            {/* Titre principal */}
            {!establishment && <Loader />}
            {establishment && (
                <>
                    <h1 className="text-3xl font-bold text-gray-800">
                        {establishment ? establishment.name : "Chargement..."}
                    </h1>

                    {/* Projets et Équipes */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-white shadow-sm rounded-xl p-4">
                            <ProjectsTab user={user} currentApp={currentApp} currentMenu={currentMenu} currentTab={currentTab} />
                        </div>
                        <div className="bg-white shadow-sm rounded-xl p-4">
                            <TeamsTab user={user} currentApp={currentApp} currentMenu={currentMenu} currentTab={currentTab} />
                        </div>
                    </div>

                    {/* Badgeuses */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-white shadow-sm rounded-xl p-4">
                            <BadgeusesTab user={user} currentApp={currentApp} currentMenu={currentMenu} currentTab={currentTab} />
                        </div>
                        {/* Holidays Tab */}

                        <div className="bg-white shadow-sm rounded-xl p-4">
                            <HolidaysTab user={user} currentApp={currentApp} currentMenu={currentMenu} currentTab={currentTab} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Establishment;
